<template>
  <div>
    <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
      <b-form role="form" @submit.prevent="handleSubmit(process)">
        <div v-if="refundVoidAction == 'VOID'">
          <div v-if="transaction.source == 'PAYMENTPLAN'">
            <div class="light-alert">
              <i class="fa-solid fa-triangle-exclamation"></i>This transaction
              is attached to a payment plan and will result in a past due
              balance.
            </div>
          </div>

          <div v-else-if="transaction.source == 'MEMBERSHIP'">
            <div class="light-alert">
              <i class="fa-solid fa-triangle-exclamation"></i>This transaction
              is attached to a membership plan and will result in a past due
              balance.
            </div>
          </div>

          Are you sure you would like to void this transaction for
          <b>{{ $root.$options.filters.currency(refundAmount) }}</b
          >?
        </div>

        <div
          v-if="
            refundVoidAction == 'REFUND' &&
              (transaction.source == 'PAYMENTPLAN' ||
                transaction.source == 'MEMBERSHIP')
          "
        >
          <div v-if="transaction.source == 'MEMBERSHIP'">
            <div class="light-alert">
              <i class="fa-solid fa-triangle-exclamation"></i>This transaction
              is part of a membership plan, partial refunds are unavailable.
            </div>
            Are you sure you would like to refund this transaction for
            <b>{{ $root.$options.filters.currency(refundAmount) }}</b
            >?
          </div>
          <div v-if="transaction.source == 'PAYMENTPLAN'">
            <div class="light-alert">
              <i class="fa-solid fa-triangle-exclamation"></i>This transaction
              is part of a payment plan, partial refunds are unavailable.
            </div>
            Are you sure you would like to refund this transaction for
            <b>{{ $root.$options.filters.currency(refundAmount) }}</b
            >?
          </div>
        </div>

        <div>
          <base-input-currency
            prependChar="$"
            v-if="
              refundVoidAction == 'REFUND' &&
                !(
                  transaction.source == 'PAYMENTPLAN' ||
                  transaction.source == 'MEMBERSHIP'
                )
            "
            name="Refund Amount"
            rules="required|money"
            label="Refund Amount"
            v-model="refundAmount"
          ></base-input-currency>
        </div>

        <!--<div
          v-if="
            transaction.source == 'MEMBERSHIP' &&
              transaction.customerMembershipBillingIsActive == false
          "
        >
          <b-checkbox v-model="setActive"
            >Reactivate Membership on
            {{ refundVoidAction.toLowerCase() }}</b-checkbox
          >
        </div>-->

        <b-button block variant="primary" type="submit" class="mt-4"
          >Process {{ refundVoidAction | title }}</b-button
        >
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import swal from "sweetalert2";

export default {
  name: "refund-void",
  props: { transaction: null, refundVoidAction: null },
  data() {
    return { refundAmount: null, origRefundAmount: null, setActive: true };
  },
  created() {
    this.refundAmount = Math.abs(this.transaction.amount / 100);
    this.origRefundAmount = Math.abs(this.transaction.amount / 100);
  },
  methods: {
    async process() {
      let self = this;

      if (
        this.refundVoidAction == "REFUND" &&
        this.refundAmount > this.origRefundAmount
      ) {
        this.$emitter.emit(
          "error",
          "The refund amount cannot be larger than the original transaction"
        );

        this.refundAmount = this.origRefundAmount;

        return;
      }

      var r = await self.$client.post("/api/transaction/refundVoid", {
        id: self.transaction.transactionResultId,
        refundAmount: (self.refundAmount * 100).toFixed(0),
        action: self.refundVoidAction,
        setActive: this.setActive,
      });

      if (r.data.isSuccess && r.data.value.isApproved) {
        swal
          .fire({
            title:
              "Transaction " +
              this.$options.filters.title(self.refundVoidAction) +
              "ed",
            text: r.data.value.statusMessage,
            buttonsStyling: false,
            confirmButtonClass: "btn btn-success",
            icon: "success",
          })
          .then(() => {
            self.$emit("refundVoidModalDone");
          });
      } else {
        this.$emitter.emit("error", "This transaction could not be refuneded");
      }
    },
  },
};
</script>
